"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableField = void 0;
const react_1 = __importDefault(require("react"));
const editable_field_styles_1 = require("./editable-field.styles");
const icons_1 = require("../../../../../icons");
const EditableField = ({ label, disabled, onEditClick, }) => (react_1.default.createElement(editable_field_styles_1.StyledEditableFieldWrapper, null, label, '  ', !!onEditClick && (react_1.default.createElement(editable_field_styles_1.StyledIconButton, { onClick: onEditClick, disabled: disabled }, react_1.default.createElement(icons_1.EditIcon, null)))));
exports.EditableField = EditableField;
